"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChainAdapter = void 0;
const caip_1 = require("@shapeshiftoss/caip");
const hdwallet_core_1 = require("@shapeshiftoss/hdwallet-core");
const types_1 = require("@shapeshiftoss/types");
const unchained = __importStar(require("@shapeshiftoss/unchained-client"));
const ErrorHandler_1 = require("../../error/ErrorHandler");
const types_2 = require("../../types");
const utils_1 = require("../../utils");
const CosmosSdkBaseAdapter_1 = require("../CosmosSdkBaseAdapter");
const SUPPORTED_CHAIN_IDS = [types_1.KnownChainIds.OsmosisMainnet];
const DEFAULT_CHAIN_ID = types_1.KnownChainIds.OsmosisMainnet;
class ChainAdapter extends CosmosSdkBaseAdapter_1.CosmosSdkBaseAdapter {
    constructor(args) {
        super({
            denom: 'uosmo',
            chainId: DEFAULT_CHAIN_ID,
            supportedChainIds: SUPPORTED_CHAIN_IDS,
            defaultBIP44Params: ChainAdapter.defaultBIP44Params,
            ...args,
        });
        this.assetId = caip_1.osmosisAssetId;
        this.parser = new unchained.osmosis.TransactionParser({ chainId: this.chainId });
    }
    getDisplayName() {
        return types_2.ChainAdapterDisplayName.Osmosis;
    }
    getName() {
        const enumIndex = Object.values(types_2.ChainAdapterDisplayName).indexOf(types_2.ChainAdapterDisplayName.Osmosis);
        return Object.keys(types_2.ChainAdapterDisplayName)[enumIndex];
    }
    getType() {
        return types_1.KnownChainIds.OsmosisMainnet;
    }
    getFeeAssetId() {
        return this.assetId;
    }
    async getAddress(input) {
        const { wallet, bip44Params = this.defaultBIP44Params, showOnDevice = false } = input;
        try {
            if ((0, hdwallet_core_1.supportsOsmosis)(wallet)) {
                const osmosisAddress = await wallet.osmosisGetAddress({
                    addressNList: (0, utils_1.toAddressNList)(bip44Params),
                    showDisplay: showOnDevice,
                });
                if (!osmosisAddress) {
                    throw new Error('Unable to generate Osmosis address.');
                }
                return osmosisAddress;
            }
            else {
                throw new Error('Wallet does not support Osmosis.');
            }
        }
        catch (error) {
            return (0, ErrorHandler_1.ErrorHandler)(error);
        }
    }
    async signTransaction(signTxInput) {
        try {
            const { txToSign, wallet } = signTxInput;
            if ((0, hdwallet_core_1.supportsOsmosis)(wallet)) {
                const signedTx = await wallet.osmosisSignTx(txToSign);
                if (!signedTx)
                    throw new Error('Error signing tx');
                return signedTx.serialized;
            }
            else {
                throw new Error('Wallet does not support Osmosis.');
            }
        }
        catch (err) {
            return (0, ErrorHandler_1.ErrorHandler)(err);
        }
    }
    async buildSendTransaction(tx) {
        try {
            const { bip44Params = this.defaultBIP44Params, chainSpecific: { fee }, sendMax, to, value, wallet, } = tx;
            const from = await this.getAddress({ bip44Params, wallet });
            const account = await this.getAccount(from);
            const amount = this.getAmount({ account, value, fee, sendMax });
            const msg = {
                type: 'cosmos-sdk/MsgSend',
                value: {
                    amount: [{ amount, denom: this.denom }],
                    from_address: from,
                    to_address: to,
                },
            };
            return this.buildTransaction({ ...tx, account, msg });
        }
        catch (err) {
            return (0, ErrorHandler_1.ErrorHandler)(err);
        }
    }
    async buildDelegateTransaction(tx) {
        try {
            const { bip44Params = this.defaultBIP44Params, chainSpecific: { fee }, sendMax, validator, value, wallet, } = tx;
            (0, CosmosSdkBaseAdapter_1.assertIsValidatorAddress)(validator, this.getType());
            const from = await this.getAddress({ bip44Params, wallet });
            const account = await this.getAccount(from);
            const validatorAction = { address: validator, type: 'delegate' };
            const amount = this.getAmount({ account, value, fee, sendMax, validatorAction });
            const msg = {
                type: 'cosmos-sdk/MsgDelegate',
                value: {
                    amount: { amount, denom: this.denom },
                    delegator_address: from,
                    validator_address: validator,
                },
            };
            return this.buildTransaction({ ...tx, account, msg });
        }
        catch (err) {
            return (0, ErrorHandler_1.ErrorHandler)(err);
        }
    }
    async buildUndelegateTransaction(tx) {
        try {
            const { bip44Params = this.defaultBIP44Params, chainSpecific: { fee }, sendMax, validator, value, wallet, } = tx;
            (0, CosmosSdkBaseAdapter_1.assertIsValidatorAddress)(validator, this.getType());
            const from = await this.getAddress({ bip44Params, wallet });
            const account = await this.getAccount(from);
            const validatorAction = { address: validator, type: 'undelegate' };
            const amount = this.getAmount({ account, value, fee, sendMax, validatorAction });
            const msg = {
                type: 'cosmos-sdk/MsgUndelegate',
                value: {
                    amount: { amount, denom: this.denom },
                    delegator_address: from,
                    validator_address: validator,
                },
            };
            return this.buildTransaction({ ...tx, account, msg });
        }
        catch (err) {
            return (0, ErrorHandler_1.ErrorHandler)(err);
        }
    }
    async buildRedelegateTransaction(tx) {
        try {
            const { bip44Params = this.defaultBIP44Params, chainSpecific: { fee }, fromValidator, sendMax, toValidator, value, wallet, } = tx;
            (0, CosmosSdkBaseAdapter_1.assertIsValidatorAddress)(toValidator, this.getType());
            (0, CosmosSdkBaseAdapter_1.assertIsValidatorAddress)(fromValidator, this.getType());
            const from = await this.getAddress({ bip44Params, wallet });
            const account = await this.getAccount(from);
            const validatorAction = { address: fromValidator, type: 'redelegate' };
            const amount = this.getAmount({ account, value, fee, sendMax, validatorAction });
            const msg = {
                type: 'cosmos-sdk/MsgBeginRedelegate',
                value: {
                    amount: { amount, denom: this.denom },
                    delegator_address: from,
                    validator_src_address: fromValidator,
                    validator_dst_address: toValidator,
                },
            };
            return this.buildTransaction({ ...tx, account, msg });
        }
        catch (err) {
            return (0, ErrorHandler_1.ErrorHandler)(err);
        }
    }
    async buildClaimRewardsTransaction(tx) {
        try {
            const { validator, wallet, bip44Params = this.defaultBIP44Params } = tx;
            (0, CosmosSdkBaseAdapter_1.assertIsValidatorAddress)(validator, this.getType());
            const from = await this.getAddress({ bip44Params, wallet });
            const account = await this.getAccount(from);
            const msg = {
                type: 'cosmos-sdk/MsgWithdrawDelegationReward',
                value: {
                    delegator_address: from,
                    validator_address: validator,
                },
            };
            return this.buildTransaction({ ...tx, account, msg });
        }
        catch (err) {
            return (0, ErrorHandler_1.ErrorHandler)(err);
        }
    }
    // @ts-ignore - keep type signature with unimplemented state
    async getFeeData({ 
    /* eslint-disable-next-line @typescript-eslint/no-unused-vars -- Disable no-unused-vars lint rule for unimplemented variable */
    sendMax, }) {
        // We currently don't have a way to query validators to get dynamic fees, so they are hard coded.
        // When we find a strategy to make this more dynamic, we can use 'sendMax' to define max amount.
        return {
            fast: { txFee: '5000', chainSpecific: { gasLimit: '300000' } },
            average: { txFee: '3500', chainSpecific: { gasLimit: '300000' } },
            slow: { txFee: '2500', chainSpecific: { gasLimit: '300000' } },
        };
    }
    async signAndBroadcastTransaction(signTxInput) {
        const { wallet } = signTxInput;
        try {
            if ((0, hdwallet_core_1.supportsOsmosis)(wallet)) {
                const signedTx = await this.signTransaction(signTxInput);
                return this.providers.http.sendTx({ body: { rawTx: signedTx } });
            }
            else {
                throw new Error('Wallet does not support Osmosis.');
            }
        }
        catch (error) {
            return (0, ErrorHandler_1.ErrorHandler)(error);
        }
    }
}
exports.ChainAdapter = ChainAdapter;
ChainAdapter.defaultBIP44Params = {
    purpose: 44,
    coinType: Number(caip_1.ASSET_REFERENCE.Osmosis),
    accountNumber: 0,
};
